import client from "@sanity/client"

export default client({
    projectId: "kcgak3vn",
    dataset: "production",
    useCdn: true,
    apiVersion: "2022-03-08"
})